export const Text = Object.freeze({
	ERROR_404: 'Error 404',
	PAGE_NOT_FOUND: 'Page not found',
	VERIFY_PHONE_TITLE: 'Verify Phone Number to Pay',
	VERIFY_PHONE_NUMBER: 'Verify Phone Number',
	VERIFY_PHONE_SUBTITLE:
		'Enter the same phone number as registered with the merchant',
	MOBILE_LABEL: 'Enter Phone Number',
	MOBILE_PLACEHOLDER: '99999 99999',
	OTP_LABEL: 'Enter OTP',
	COUNTRY_CODE: '+91',
	VERIFY: 'Verify',
	PROCEED: 'Proceed',
	EDIT: 'Edit',
	TOTAL: 'Total',
	TOTAL_AMOUNT: 'TOTAL AMOUNT',
	PAY_NOW: 'PAY NOW',
	RECURRING_AMOUNT: 'RECURRING AMOUNT',
	PAID: 'Paid',
	SUCCESSFULLY: 'successfully',
	TRANSACTION_ID: 'TRANSACTION ID',
	COPY: 'Copy',
	POWERED_BY: 'Powered by',
	PAYMENT_REQUEST_FOR: 'PAYMENT REQUESTED FOR',
	PAYMENT_LINK_FOR: 'PAYMENT LINK FOR',
	PAID_SUCCESSFULLY: 'Paid successfully',
	LINK_CANCELLED: 'Link cancelled',
	LINK_EXPIRED: 'Link expired',
	PAID_TO: 'PAID TO',
	LINK_CREATED_BY: 'LINK CREATED BY',
	LINK_INVALID: 'This payment link is invalid.',
	CANCELLED_BY_SUFFIX: ' has cancelled this link.',
	EXPIRED_ON: 'expired on',
	QUERIES_PREFIX: 'For any queries, you can contact ',
});
